<template>
  <v-container id="regular-forms" fluid tag="section">
    <base-material-card color="#ac8a2e" icon="mdi-account-box" inline class="px-5 py-3" title="Jugadores">
      <template v-if="$can('M_jugadores_edita')" v-slot:after-title>
        <v-btn color="#ac8a2e" dark icon @click="goToNewJugadorForm('new', 0)">
          <v-icon large color="#ac8a2e">
            mdi-account-plus
          </v-icon>
        </v-btn>
      </template>
      <v-row align="end" justify="end">
        <v-col cols="5">
          <v-text-field v-model="buscar" append-icon="mdi-magnify" class="ml-auto" color="gold" label="Buscar" hide-details single-line style="max-width: 250px;" />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="jugadores"
        :search.sync="buscar"
        :sort-by="['fullName']"
        :sort-desc="[false]"
        multi-sort
        @click:row="showItem"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip v-if="$can('M_jugadores_edita')" content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="goToNewJugadorForm('edit', item.id)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="goToContratos(item)">
                mdi-file-document-multiple
              </v-icon>
            </template>
            <span>Ir a contratos</span>
          </v-tooltip>
          <v-tooltip v-if="$can('M_contratos')" content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small v-bind="attrs" class="mr-2" v-on="on" @click.stop="goToDocumentaciones(item)">
                mdi-notebook
              </v-icon>
            </template>
            <span>Documentaciones</span>
          </v-tooltip>
          <v-tooltip v-if="$can('M_jugadores_edita')" content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small v-bind="attrs" class="mr-2" v-on="on" @click.stop="sendResetPassword(item)">
                mdi-email-alert
              </v-icon>
            </template>
            <span>Enviar restablecimiento de contraseña</span>
          </v-tooltip>
          <v-tooltip v-if="$can('M_jugadores_edita')" content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small v-bind="attrs" v-on="on" @click.stop="darDeBaja(item)">
                mdi-delete
              </v-icon>
            </template>
            <span>Inactivar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import confirm from '../../../components/confirm'

  export default {
    name: 'ListadoJugadores',
    components: {
      confirm,
    },
    data () {
      return {
        buscar: undefined,
        headers: [
          { text: 'Apellido y nombre', align: 'start', sortable: true, value: 'fullName' },
          { text: 'Dni', value: 'user.dni' },
          { text: 'Posición', value: 'posicion_detalle.descripcion' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        jugadores: [],
        editedIndex: -1,
        menu: false,
        notificar: false,
        showNotificar: false,
        dataForm: {
          id: '',
          fecha_nacimiento: '',
          pierna_habil: '',
          posicion_detalle: '',
          activo_sn: '',
          user: {
            id: '',
            dni: '',
            name: '',
            lastname: '',
            domicilio: '',
            celular: '',
            email: '',
            observacion: '',
          },
        },
      }
    },
    computed: {
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
    },
    created () {
      this.getJugadores()
    },
    methods: {
      showItem (item) {
        this.goToNewJugadorForm('show', item.id)
      },
      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'Está seguro de eliminar el registro ?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
            this.getJugadores()
          }
        })
      },
      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/jugador/' + item.id,
        ).then().catch(error => {
          console.log(error.response.data)
          if (error.response) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.message] })
          }
        })
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      getJugadores: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador' }).then(response => { this.jugadores = response })
      },
      sendMailResetPassword: async function () {
        if (this.dataForm.user.email != null && this.dataForm.user.email !== '') {
          this.$store.dispatch('axiosMod/sendMailResetPassword', this.dataForm.user.email)
        } else {
          this.$store.commit('toast/show', { tipo: 'error', messages: ['El usuario debe tener un correo electrónico asociado'] })
        }
      },
      sendResetPassword: function (item) {
        this.editedIndex = this.jugadores.indexOf(item)
        this.dataForm = Object.assign({}, item)
        this.sendMailResetPassword()
      },
      goToNewJugadorForm: function (modeVal, userId) {
        this.$router.push({ name: 'Alta Jugador', params: { mode: modeVal, id: userId } })
      },
      goToContratos: function (item) {
        this.$router.push({ name: 'Contratos', params: { idJugador: item.id } })
      },
      goToDocumentaciones: function (item) {
        this.$router.push({ name: 'Documentaciones', params: { idJugador: item.id } })
      },
      darDeBaja: function (item) {
        this.$refs.confirm.open('Alerta', 'Está seguro de inactivar el jugador ?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.dataForm = Object.assign({}, item)
            this.darDebajaConfirm(item)
          }
        })
      },
      darDebajaConfirm: async function (item) {
        await this.$http({
          method: 'put',
          url: '/api/jugador_baja/' + this.dataForm.id,
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Baja de jugador exitosa'] })
          this.getJugadores()
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        })
      },
    },
  }
</script>
